import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	max-width: calc(100% - 80px);
	height: 40px;
	display: flex;
	gap: 30px;
	overflow-x: scroll;
	overflow-y: hidden;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export { StyledContainer };
